import Vue from 'vue';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { helper } from '../Utilities/helper';

const version = 'v1';
const addWithEmailCompanyApi = `${version}/Company/addWithEmail`;
const deleteCompanyApi = `${version}/Company/delete`;
const getAllCompaniesApi = `${version}/Company/getAll`;
const downloadInstanceConfigApi = `${version}/Company/downloadInstanceConfig`;
const sendWelcomeEmailApi = `${version}/Company/sendWelcomeEmail`;
const updateCompanyApi = `${version}/Company/update`;
const addCompanyApiWithDetails = `${version}/Company/addWithDetails`;
const addSubscriptionApi = `${version}/CompanySubscription/register`;
const extendTrialPeriodApi = `${version}/CompanySubscription/extendTrialPeriod`;
const endTrialPeriodApi = `${version}/CompanySubscription/endTrialPeriod`;
const unsubscribeApi = `${version}/CompanySubscription/unsubscribe`;
const checkSubdomainApi = `${version}/InstanceManager/isSubdomainValid`;
const terminateTrialSubscriptionApi = `${version}/CompanySubscription/terminateTrialSubscription`;
const recreateSubscriptionApi = `${version}/CompanySubscription/recreate`;


export const state = Vue.observable({
	instances: [],
	instancesCount: 0
});

export const mutations = {
	async getInstances(params = {}) {
		let res = await axios.get(getAllCompaniesApi, { params: params });
		res.data.result.items.forEach(c => {
			c.companySubscription = c.companySubscription ?? {},
			c.companyAddons = c.companyAddons ?? []
		});
		state.instances = res.data.result.items;
		state.instancesCount = res.data.result.totalCount;
	},
	async downloadInstanceConfig(companyId) {
		const response = await axios.get(downloadInstanceConfigApi, { params: { companyId: companyId }, responseType: 'blob' });
		const fileName = helper.getFileNameFromResponse(response);

		fileDownload(response.data, fileName ?? `subscriptionAccount-${companyId}.config`);
	},
	async sendWelcomeEmail({ companyId, password }) {
		return await axios.get(sendWelcomeEmailApi, { params: { companyId, password } });
	},
	async extendTrialPeriod({ companySubscriptionId, trialEnd }) {
		const response = await axios.post(extendTrialPeriodApi, { companySubscriptionId, trialEnd });
		this.getInstances();
		return response;
	},
	async endTrialPeriod(companySubscriptionId) {
		const response = await axios.post(`${endTrialPeriodApi}/${companySubscriptionId}`);
		this.getInstances();
		return response;
	},
	async unsubscribe(companyId) {
		const response = await axios.post(`${unsubscribeApi}/${companyId}`);
		this.getInstances();
		return response;
	},
	async isSubdomainValid(subdomain) {

		const response = await axios.get(`${checkSubdomainApi}/${subdomain}`);
		return response.data.success;
	},
	async terminateTrialSubscription(companySubscriptionId) {
		const response = await axios.post(`${terminateTrialSubscriptionApi}/${companySubscriptionId}`);
		this.getInstances();
		return response;
	},
	async recreateSubscription( companySubscriptionId, trialEnd, planId, quantity, overrideUnitPrice ) {
		const response = await axios.post(recreateSubscriptionApi, 
			{ companySubscriptionId, trialEnd, planId, quantity, overrideUnitPrice }
		);
		this.getInstances();
		return response;
	},
	async addCompanyWithEmailVerification(newCompany) {
		return await axios.post(addWithEmailCompanyApi, newCompany);
	},
	async addInstance(newInstance) {
		let response = await axios.post(addCompanyApiWithDetails, newInstance);
		this.getInstances();
		return response;
	},
	async updateInstance(updatedInstance) {
		return await axios.put(updateCompanyApi, updatedInstance);
	},
	async deleteInstance(instance) {
		let deleteResponse = await axios.post(deleteCompanyApi, instance);
		await this.getInstances();
		return deleteResponse;
	},
	async addSubscription(subscription) {
		let response = await axios.post(addSubscriptionApi, subscription);
		this.getInstances();
		return response;
	}
};
